import { z } from 'zod';
import { SummaryLengthSchema, SupportedModels } from './link-preview.js';

export const TweetSummaryModeSchema = z.enum(['summary', 'explain']);
export type TweetSummaryMode = z.infer<typeof TweetSummaryModeSchema>;

export const TweetSummarySearchModeSchema = z.enum(['auto', 'off']);
export type TweetSummarySearchMode = z.infer<typeof TweetSummarySearchModeSchema>;

export const SummaryCustomPromptSchema = z
  .string()
  .trim()
  .min(1)
  .max(500, 'Custom prompt must be 500 characters or fewer.');

export const TweetSummaryRequestSchema = z.object({
  summaryLength: SummaryLengthSchema.optional(),
  model: SupportedModels.optional(),
  includeImages: z.boolean().optional(),
  customPrompt: SummaryCustomPromptSchema.optional(),
  mode: TweetSummaryModeSchema.optional(),
  searchMode: TweetSummarySearchModeSchema.optional(),
});

export type TweetSummaryRequest = z.infer<typeof TweetSummaryRequestSchema>;
